import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //页面缓存
    // pageCache: null
  },
  //同步修改state，使用$store.commit('xxx',data)
  mutations: {
    // setPageCache(state, key, data) {
    //   state.pageCache[key] = data;
    // }
  },
  //异步修改state，使用$store.dispatch('xxx',data)
  actions: {
  },
  modules: {
  },
  getters: {
    // pageCache(state){
    //   return state.pageCache
    // }
  }
})
